import { Navigate, useLocation } from "react-router-dom";
import { useMenuAccess } from "../contexts/MenuAccessContext";

function LoadingSpinner() {
    return (
        <div className="flex items-center justify-center min-h-[40vh]">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900" />
        </div>
    );
}

/** メニューに未登録の機能 URL へのアクセスをダッシュボードへ戻す */
export default function MenuRouteGuard({ children }) {
    const location = useLocation();
    const { loading, isPathAllowed } = useMenuAccess();

    if (loading) return <LoadingSpinner />;

    if (!isPathAllowed(location.pathname)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
